import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=36c91217&scoped=true&"
import script from "./BatchImport.vue?vue&type=script&lang=ts&"
export * from "./BatchImport.vue?vue&type=script&lang=ts&"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=36c91217&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c91217",
  null
  
)

export default component.exports